
import './inputs.css'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import BoxInfo from '../BoxInfo'
import { forwardRef } from 'react'
const SelectNesting = forwardRef((props, ref) => {

    const {
        children,
        onChange,
        onFocus,
        onClick,
        className="",
        // valueName,
        // valueText, 
        labelClass = '',
        id,
        style,
        // values=[],
        value = "",
        type = "text",
        title = "",
        tooltip = false,
        tooltipText = "",
        boxInfo = false,
        containerClass = "",
        placeholder = "",
        defaultValue= ""
     } = props;

    return (

        <div className={`${containerClass} content-select`}>
            {tooltip && <Tooltip anchorSelect={`#${id}`} content={tooltipText} place="top" />}
            {boxInfo ? <BoxInfo
                id={id}
                titleClass='mr-0-4'
                title={title}
                place="top" 
                containerClass='mr-0-5'
                content={tooltipText}
            /> :
                <label className={`${labelClass} label-select mr-2`}>
                    {title}
                </label>
            }
            <select
                ref={ref}
                id={id}
                type={type}
                onChange={onChange}
                className={`input-n select-nesting ${className}`}
                placeholder={placeholder}
                onClick={onClick}
                onFocus={onFocus}
                // value={value}
                style={style}
                defaultValue={defaultValue}
                
            >
              {children}
            </select>
        </div>

    )

})


 

export {
    SelectNesting 
}